import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import router from "./utils/routes/router";
import locale from 'element-ui/lib/locale/lang/es'
import './fonts-DSEG/css/dseg.css'



Vue.use(Element,{locale})
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
